<template>
	<div style="position: relative;">
		<div v-if="sy_flag" class="sybg">
			<div style="padding-top: 18vh;text-align: center;">
				<img src="../assets/sy_title.png" style="width: 85%;" />
			</div>
			<div style="position: absolute;bottom: 15px;left: 0;width: 100%;text-align: center;">
				<div>
					<input v-model.trim="phone" type="number" class="input" placeholder="请输入您的手机号" />
				</div>
				<div style="margin-top: 30px;">
					<img @click="ksyx" src="../assets/ksyx.png" style="width: 65%;" />
				</div>
				
				<div style="margin-top: 30px;">
					<img src="../assets/logo2.png" style="width: 70%;" />
				</div>
			</div>
			<img @click="getPrize" src="../assets/wdjp.png"
				style="position: absolute;bottom: 100px;right: 0;width: 50px;" />
			<img @click="yxgz_flag=true" src="../assets/yxgz.png"
				style="position: absolute;top: 18vh;right: 0;width: 50px;" />

		</div>
		<div v-if="yxgz_flag"
			style="position: fixed;top: 0px;left: 0;width: 100vw;height: 100vh;background-color: rgba(0,0,0,0.6);text-align: center;">
			<div style="position: absolute;top: 50%;left: 0;width: 100%;transform: translateY(-50%);">
				<img src="../assets/gzwz.png" style="width: 95%;" />
				<img @click="yxgz_flag=false" src="../assets/gz_back.png" style="width: 45%;margin-top: 40px;" />
			</div>

		</div>


		<div v-if="wdjp_flag" class="wdjpbg">
			<div style="padding-top: 30px;text-align: center;">
				<img src="../assets/wdjp_title.png" style="width: 90%;" />
			</div>
			<div style="padding-top: 40px;text-align: center;">
				<img src="../assets/jp.png" style="width: 90%;" />
			</div>
			<div style="height: 200px;"></div>
			<div style="position: absolute;bottom: 15px;left: 0;width: 100%;text-align: center;">
				<div>
					<img @click="wdjp_flag=false,sy_flag=true" src="../assets/wdjp_back.png" style="width: 60%;" />
				</div>
				<div style="margin-top: 20px;">
					<img src="../assets/logo2.png" style="width: 70%;" />
				</div>
			</div>
		</div>
		<div v-if="dt_flag" class="dtbg">
			<div style="text-align: center;padding-top: 30px;">
				<div style="color: #FFFFFF;font-size: 1.3rem;">{{getTime(times)}}</div>
				<img v-for="(item,index) in question_list" v-if="index==question_index" :src="item.question" style="width: 90%;margin-top: 20px;" />
				
			</div>
			<div style="width: 90%;margin: 0 auto;margin-top: 30px;">
				<!-- <div style="display: grid;grid-template-columns: 1fr 1fr;gap: 0px;">
					<div v-for="(item,index) in question_list[question_index].options" :style="index%2==0?'display: flex;justify-content: flex-start;margin-top: 15px;':'display: flex;justify-content: flex-end;margin-top: 15px;'">
						<div style="display: inline-block;padding: 5px 20px;border: 1px solid #FFFFFF;color: #FFFFFF;font-size: 1.4rem;border-radius: 15px;text-align: center;">{{item.option}}</div>
					</div>
				</div> -->
				<div v-for="(item,index) in question_list[question_index].options" v-if="index%2==0" style="display: flex;justify-content: space-between;">
					<div @click="xuanze(index)" :class="xx_word_list.indexOf(question_list[question_index].options[index])>-1?'xuanxiang xxact':'xuanxiang'">{{question_list[question_index].options[index].option}}</div>
					<div @click="xuanze(index+1)" :class="xx_word_list.indexOf(question_list[question_index].options[index+1])>-1?'xuanxiang xxact':'xuanxiang'">{{question_list[question_index].options[index+1].option}}</div>
				</div>
			</div>
			<div v-if="jx_flag" style="position: fixed;top: 0;left: 0;height: 100vh;width: 100%;overflow-y: auto;text-align: center;" class="jxbg">
				<img :src="question_list[question_index].analysis" style="width: 90%;padding-top: 40px;" />
				<div style="position: absolute;top: 10px;right: 10px;">
					<van-circle
					  v-model="currentRate"
					  :clockwise="false"
					  size="40"
					  :text="(Math.floor(currentRate/20+1)>5?5:Math.floor(currentRate/20+1))+'s'"
					  :color="hd_flag?'#1ab20a':'#f7000a'"
					  layer-color="rgba(255,255,255,0.3)"
					  stroke-width="80"
					/>
				</div>
			</div>
		</div>
		
		<div v-if="cj_flag" class="wdjpbg">
			<div style="padding-top: 30px;text-align: center;">
				<img src="../assets/wdjp_title.png" style="width: 90%;" />
			</div>
			
			<div class="cc">
				<div style="position: relative;z-index: 2;font-size: 0;text-align: center;">
					<img class="yuanhuan" src="img/cjhuan.png" style="visibility: ;display: inline;">
				</div>
						
				<section id="turntable" class="gb-turntable">
					<div class="gb-turntable-container">
						<canvas class="gb-turntable-canvas" style="width: 60vw;height: 60vw;margin-top: 10vw;">抱歉！浏览器不支持。</canvas>
					</div>
					<!-- <div>抽奖</div> -->
					<img class="gb-turntable-btn" src="img/cjanniu.png" />
					<!-- <a class="gb-turntable-btn" href="javascript:;">抽奖</a> -->
				</section>
						
			</div>
			<div style="position: absolute;bottom: 15px;left: 0;width: 100%;text-align: center;">
				<div>
					<img src="../assets/logo2.png" style="width: 70%;" />
				</div>
			</div>
		</div>

		<div v-if="zj_flag" class="wdjpbg">
			<div style="padding-top: 30px;text-align: center;">
				<img src="../assets/wdjp_title.png" style="width: 90%;" />
			</div>
			<div style="padding-top: 40px;text-align: center;">
				<img src="../assets/zjl.png" style="width: 90%;" />
			</div>
			<div style="height: 200px;"></div>
			<div style="position: absolute;bottom: 15px;left: 0;width: 100%;text-align: center;">
				<div>
					<img @click="zj_flag=false,sy_flag=true" src="../assets/wdjp_back.png" style="width: 60%;" />
				</div>
				<div style="margin-top: 20px;">
					<img src="../assets/logo2.png" style="width: 70%;" />
				</div>
			</div>
		</div>
		<div v-if="wzj_flag" class="wdjpbg">
			<div style="padding-top: 30px;text-align: center;">
				<img src="../assets/wdjp_title.png" style="width: 90%;" />
			</div>
			<div style="padding-top: 100px;text-align: center;">
				<img src="../assets/wzj.png" style="width: 90%;" />
			</div>
			<div style="height: 200px;"></div>
			<div style="position: absolute;bottom: 15px;left: 0;width: 100%;text-align: center;">
				<div>
					<img @click="wzj_flag=false,sy_flag=true" src="../assets/wdjp_back.png" style="width: 60%;" />
				</div>
				<div style="margin-top: 20px;">
					<img src="../assets/logo2.png" style="width: 70%;" />
				</div>
			</div>
		</div>
		
		<div v-if="jz_flag" id="jiazai"
			style="position: fixed;top: 0;left: 0;height: 100%;width: 100%;background-color: rgba(0,0,0,0.5);z-index: 99;">
			<img src="../assets/loading.gif"
				style="width: 30px;position: absolute;top: 45%;left: 50%;transform: translate(-50%);" />
		</div>
	</div>

</template>

<script>
	import {
		myprize,
		check,
		question,
		receive
	} from "@/api/index";
	import Vue from 'vue';
	import Toast from 'vant/lib/toast';
	import 'vant/lib/toast/style';
	Vue.use(Toast);
	
	import Circle from 'vant/lib/circle';
	import 'vant/lib/circle/style';
	Vue.use(Circle);
	
	export default {
		name: 'index',
		components: {

		},
		data() {
			return {
				cj_flag:false,
				zj_flag:false,
				wzj_flag:false,
				sy_flag: true,
				phone: null,
				yxgz_flag: true,
				wdjp_flag: false,

				jz_flag: false,

				prize_flag: false,

				dt_flag: false,

				question_list: [],
			
				question_index: 0,
				
				xx_word_list:[],
				
				
				times:20,
				djs_timmer:null,
				jx_djs_timmer:null,
				
				hd_flag: false,
				jx_flag: false,
				currentRate:100,
				
				
				fenshu:0
			}
		},

		methods: {
			jx_djs(){
				this.jx_flag = true
				this.jx_djs_timmer = setInterval(()=>{
					this.currentRate = this.currentRate - 1
					if(this.currentRate==0){
						clearInterval(this.jx_djs_timmer)
						this.jx_djs_timmer=null
						this.currentRate = 100
						this.next()
						// this.jx_flag = false
						
					}
				},50)
			},
			djs(){
				// this.times--
				this.djs_timmer = setInterval(()=>{
					this.times--
					if(this.times==0){
						clearInterval(this.djs_timmer)
						this.djs_timmer=null
						Toast('时间到');
						this.isWrong()
						
					}
				},1000)
			},
			next(){
				console.log("question_list.length：",this.question_list.length)
				console.log("question_index：",this.question_index)
				if (this.question_index+1==this.question_list.length) {
					
					this.end()
				} else{
					this.jx_flag = false
					this.question_index++
					this.xx_word_list=[]
					this.times=20
					this.djs()
				}
			},
			end(){
				let post = {
					"phone": this.phone,"score":this.fenshu
				}
				post = JSON.stringify(post)
				receive({
					message: post
				}).then(data => {
					if(this.fenshu==3){
						this.cj_flag = true
						this.dt_flag = false
						this.jx_flag = false
						this.$nextTick(()=>{
							this.showCj()
						})
					}else{
						this.wzj_flag = true
						this.dt_flag = false
						this.jx_flag = false
						
					}
				}).catch(data => {
					Toast('服务器错误，请重试');
					this.jz_flag = false
				})
				
				
			},
			getTime(time){
				let min = Math.floor(time/60)
				let sec = time%60
				
				return (min>=10?min:('0'+min))+':'+(sec>=10?sec:('0'+sec))
			},
			xuanze(index){
				let flag = false
				console.log('index:',this.xx_word_list.indexOf(this.question_list[this.question_index].options[index]))
				if(this.xx_word_list.indexOf(this.question_list[this.question_index].options[index])>-1){
					this.xx_word_list.splice(this.xx_word_list.indexOf(this.question_list[this.question_index].options[index]),1)
					flag = true
				}
				if (this.xx_word_list.length>=2) {
					return
				}
				if(!flag){
					this.xx_word_list.push(this.question_list[this.question_index].options[index]) 
				}
				
				if(this.xx_word_list.length==2){
					this.judge()
				}
			},
			judge(){
				clearInterval(this.djs_timmer)
				this.djs_timmer=null
				if (this.question_list[this.question_index].right==(this.xx_word_list[0].option+this.xx_word_list[1].option)) {
					Toast('回答正确');
					this.isRight()
				} else{
					Toast('回答错误');
					this.isWrong()
				}
			},
			isRight(){
				this.jx_djs()
				this.fenshu++
				this.hd_flag=true
			},
			isWrong(){
				this.jx_djs()
				this.hd_flag=false
			},
			ksyx() {
				if (!this.phone) {
					Toast('请输入您的手机号');
					return
				}
				if (!(/^1[3456789]\d{9}$/.test(this.phone))) {
					Toast('请输入正确的手机号');
					return;
				}
				localStorage.hbbwyxyxpro_phone = this.phone
				let post = {
					"phone": this.phone
				}
				post = JSON.stringify(post)
				this.jz_flag = true
				question({
					message: post
				}).then(data => {
					this.dt_flag = true
					this.sy_flag = false
					this.jz_flag = false
					this.question_list = data.data.data
					this.fenshu=0
					this.question_index=0
					this.xx_word_list=[]
					this.times=20
					this.djs()
				}).catch(data => {
					Toast('服务器错误，请重试');
					this.jz_flag = false
				})
				// check({
				// 	message: post
				// }).then(data => {
				// 	if (data.data.code + '' == '1') {
				// 		question({
				// 			message: post
				// 		}).then(data => {
				// 			this.dt_flag = true
				// 			this.sy_flag = false
				// 			this.jz_flag = false
				// 			this.question_list = data.data.data
				// 			this.fenshu=0
				// 			this.question_index=0
				// 			this.xx_word_list=[]
				// 			this.times=20
				// 			this.djs()
				// 		}).catch(data => {
				// 			Toast('服务器错误，请重试');
				// 			this.jz_flag = false
				// 		})
				// 	} else {
				// 		this.jz_flag = false
				// 		Toast(data.data.msg);
				// 	}

				// }).catch(data => {
				// 	Toast('服务器错误，请重试');
				// 	this.jz_flag = false
				// })
			},
			getPrize() {

				if (!this.phone) {
					Toast('请输入您的手机号');
					return
				}
				if (!(/^1[3456789]\d{9}$/.test(this.phone))) {
					Toast('请输入正确的手机号');
					return;
				}
				localStorage.hbbwyxyxpro_phone = this.phone
				let post = {
					"phone": this.phone
				}
				post = JSON.stringify(post)
				this.jz_flag = true
				myprize({
					message: post
				}).then(data => {
					console.log(data)
					if (data.data.code == 1) {
						this.wdjp_flag = true
						this.sy_flag = false
					} else {
						Toast('暂无奖品');
					}
					this.jz_flag = false
				}).catch(data => {
					Toast('服务器错误，请重试');
					this.jz_flag = false
				})
			},
			
			showCj(){
				let that = this
				var prizes = [{
					text: '谢谢参与'
				}, {
					text: '光影河博通用票'
				},{
					text: '谢谢参与'
				}, {
					text: '谢谢参与'
				}];
				var prizeid, title, jyuser_id
				$(document).ready(function() {
					gbTurntable.init({
						id: 'turntable',
						config: function(callback) {
							// 获取奖品信息
							// callback && callback(['11元红包','2元红包','3元红包','4元红包','5元红包','6元红包']);
							callback && callback(prizes);
						},
						getPrize: function(callback) {
							// 获取中奖信息
							// var num = Math.random() * prizes.length >>> 0, //奖品ID
							// 	chances = num; // 可抽奖次数
							
							if (that.fenshu==3) {
								let post = {
									"phone": that.phone
								}
								post = JSON.stringify(post)
								$.ajax({
									type: "get",
									url: "https://appapi.hebei.com.cn/api/2025hbktddpyx/api/reward.php",
									datatype: "json",
									data: {
										message: post
									},
									beforeSend: function() {
										that.jz_flag = true
									},
									complete: function() {
										that.jz_flag = false
									},
									//成功返回之后调用的函数
									success: function(data) {
										console.log(data)
										data = JSON.parse(data)
										
										if (data.code + '' == '1') {
											callback && callback([data.data.prizeid, 0]);
											prizeid = data.data.prizeid;
											title = data.data.title;
										} else {
											choujiangflag = true;
											Toast(data.msg);
											
										}
									},
									error: function(data) {
										
									}
								})
							} else{
								callback && callback([0, 0]);
								prizeid = 1;
								title = '谢谢参与';
							}
							
							
						},
						gotBack: function(data) {
							// alert('恭喜抽中' + data);
							if (prizeid == 1) {
								that.cj_flag = false
								that.zj_flag = true
								
							} else {
								that.cj_flag = false
								that.wzj_flag = true
							}
							choujiangflag = true;
						}
					});
				});
			}


		},
		mounted() {
			if (localStorage.getItem("hbbwyxyxpro_phone")) {
				this.phone = localStorage.getItem("hbbwyxyxpro_phone")
			}
			// this.djs()
			// this.jx_djs()
			
			// this.showCj()
		}
	}
</script>

<style scoped="scoped">
	.sybg {
		background-image: url(../assets/sybg.jpg);
		background-size: 100% 100%;
		position: relative;
		min-height: 100vh;
		width: 100vw;
	}

	.wdjpbg {
		background-image: url(../assets/wdjpbg.jpg);
		background-size: 100% 100%;
		position: relative;
		min-height: 100vh;
		width: 100vw;
	}

	.dtbg {
		background-image: url(../assets/dtbg.jpg);
		background-size: 100% 100%;
		position: relative;
		min-height: 100vh;
		width: 100vw;
	}
	.jxbg{
		background-image: url(../assets/dtbg.jpg);
		background-size: 100% 100%;
	}
	.input {
		width: 60%;
		height: 50px;
		border: 1px solid #003665;
		border-radius: 16px;
		color: #000000;
		font-size: 1.1rem;
		line-height: 50px;
		/* padding-left: 10px; */
		box-sizing: border-box;
		text-align: center;
	}

	.input::placeholder {
		color: #3e819a;
		font-size: 1.1rem;
	}
	.xuanxiang{
		padding: 5px 20px;
		border: 1px solid #FFFFFF;
		color: #FFFFFF;
		font-size: 1.4rem;
		border-radius: 15px;
		text-align: center;
		margin-top: 20px;
	}
	.xxact{
		color: #3be1ff;
		border: 1px solid #3be1ff;
	}
	
	
</style>
